import axios from 'axios'     //引入
import { Dialog } from 'vant';
import router from './../router'

// 修改这里
let baseURL = 'https://xhbwekapi.m8yule999.top'
 
sessionStorage.setItem("baseURL", baseURL)

// 开发环境也使用远程 API
if(process.env.NODE_ENV=="development"){
  baseURL = 'https://xhbwekapi.m8yule999.top'
}

let config = {
    baseURL: baseURL,
    timeout: 10000
}
const _axios = axios.create(config)

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
    config => {
        //如果有需要在这里开启请求时的loading动画效果
        // Authorization:Bearer hPxf6a8TQnCkExTYxceujYgXoW9GXB9909zsZtpvabw6yO9ngcMVKgLx4mzD
        let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''
        config.headers.Authorization = 'Bearer ' + token;  //添加token,需要结合自己的实际情况添加，
        
        // 👇 添加这一行 - 语言头
        let lang = localStorage.getItem('language') || 'zh'
        config.headers['Accept-Language'] = lang
        
        return config;
    },
    err => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
    res => {
        //在这里关闭请求时的loading动画效果
        //这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写

        // 移除了401认证失败的弹窗提示
        if (res.data.code === 401) {
            localStorage.clear();
            sessionStorage.clear();
            // 不再弹出弹窗，也不跳转到登录页
        }
        return res;
    },
    err => {
        if (err) {
            //在这里关闭请求时的loading动画效果
            // Toast("请求网络失败")
        }
        return Promise.reject(err);
    }
);

//封装post,get方法
const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                params,
                method: 'GET'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    },
    post(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                data: params,
                method: 'POST'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    }
}


export default http


// WEBPACK FOOTER //
// ./src/http/http.js